import { ReactNode } from 'react';

export type WorkspaceResourceListCellValueKind = 'component' | 'primitive';

/**
 * Applies one empty-value policy across workspace resource lists.
 * Primitive values use a compact ASCII hyphen; component cells remain empty.
 */
export const renderWorkspaceResourceListCellValue = (
    value: ReactNode,
    kind: WorkspaceResourceListCellValueKind = 'primitive',
): ReactNode => {
    const isEmpty = value === null || value === undefined || value === '';

    if (!isEmpty) {
        return value;
    }

    return kind === 'component' ? null : '-';
};
